import React, { Component } from 'react';
import heroImg from '../../static/warehouse.jpg';
import productImg from '../../static/pails.png';
import './Home.css';


class Home extends Component {

  render() {
    return (
      <div>
        <div style={{background: "url("+heroImg+")"}} className="hero">
          <h1 className="text-center">Industrial Packaging Specialists</h1>
          <p className="text-center">
            <button className="btn btn-primary">
              <a href="/products">See our products</a>
            </button>
            <button className="btn btn-primary">
              <a href="/contact">Request a free quote</a>
            </button>

          </p>
        </div>
        <section>
          <div className="container">
            <h2> Welcome to CPAK inc. </h2>
            <p>
              Our mission is to establish and maintain personal relationships with those that
              we do business with. Breaking the gap between business and personal relationships
              is at the forefront of our establishment. CPAK is the destruction of the deceptive
              day to day, business to business world. Our products are outmatched, our service
              will exceed expectation, our family is your family.
            </p>
            <button className="btn btn-primary">
              <a href="/about">Learn more</a>
            </button>

            <hr />
            <div className="row">
              <div className="col-md-6">
                <h2> Our large inventory of packaging products </h2>
                <p>
                  Plastic pails are CPAK’s most popular product by in large. We stock locally, a variety of
                  plastic pails. Our pails range in size, color, certification, resin, and end-user utilization.
                  Plastic pails over the years have been used in every region of the world for every use thought
                  possible, or previously deemed impossible. From gathering water in the middle east to transporting
                  lubricants and chemicals in the midwest, plastic pails are essential to our way of living. The
                  majority CPAK’s pails are FDA approved for honey, flavors, seeds, ice cream and any food product
                  that you desire.
                </p>
                <button className="btn btn-primary">
                  <a href="/products">See our products</a>
                </button>
              </div>
              <div className="col-md-6 product-image">
                <img src={productImg} alt="Different sizes of plastic pails" title="Plastic Pails" />
              </div>
            </div>

          </div>
        </section>
      </div>
    )
  }
}

export default Home;



/** WEBPACK FOOTER **
 ** ./src/components/Home/Home.js
 **/